import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row space-x-2"
}
const _hoisted_3 = { class: "ml-2 text-sm" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row space-x-2"
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`ml-2 flex justify-center px-1 rounded-md items-center text-sm bg-h-warning-100 text-h-warning-500`)
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.material?.lessons.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", {
            pt: `Plano${_ctx.material?.lessons.length > 1 ? "s" : ""}:`,
            en: `Plan${_ctx.material?.lessons.length > 1 ? "s" : ""}:`,
          })), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.material?.lessons, (lesson, i) => {
            return (_openBlock(), _createElementBlock("p", {
              key: i,
              class: _normalizeClass(`flex justify-center rounded-md items-center px-1 text-sm ${
          lesson === 'ESSENTIAL'
            ? 'bg-h-info-100 text-h-primary-500'
            : 'bg-h-secondary-50 text-h-secondary-600'
        }`)
            }, _toDisplayString(_ctx.$t("labels.generic", {
            pt: `${_ctx.getMaterialTypePT(lesson)}`,
            en: `${lesson}`,
          })), 3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
            pt: `Sem plano`,
            en: `No plan`,
          })), 1)
        ]))
  ]))
}